import * as THREE from 'three';
import GUI from 'lil-gui';

import Camera from './camera';
import Renderer from './renderer';
import Light from './light';
import Controls from './controls';
import Stats from './stats';
import Loader from './loader';

export default class WebGl {
	/**
	 * @param {string} containerSelector - Selector
	 * @param {Object} options - User options
	 */
	constructor(containerSelector) {
		if (!containerSelector) {
			console.warn('Missing \'containerSelector\' property');
			return;
		}

		// Set container property to container element
		this.targetElement = document.querySelector(containerSelector);

		if (!this.targetElement) {
			return;
		}

		this.debug = true;

		// Main scene creation
		this.scene = new THREE.Scene();
		this.scene.fog = new THREE.FogExp2(0xffffff, 0.0008);

		// Main renderer constructor
		this.renderer = new Renderer(this.scene, this.targetElement);

		// Camera
		this.camera = new Camera(this.renderer.threeRenderer, this.scene );

		// Controls
		this.controls = new Controls(this.camera.threeCamera, this.targetElement);

		// Models
		this.loader = new Loader(this.scene);

    	// Create and place lights in scene
		this.light = new Light(this.scene);
    	const lights = ['ambient', 'directional', 'point', 'hemi'];
    	//const lights = ['directional'];
    	//const lights = ['directional'];
    	lights.forEach((light) => this.light.place(light));

		this.setWorld();
		this.setDebug();
		this.animate();

	}

	setWorld() {
		this.geometry = new THREE.BoxGeometry(1, 1, 1);
		this.material = new THREE.MeshStandardMaterial({
			color: 0x00ff00,
			shading: THREE.FlatShading,
			roughness: 1,
			metalness: 0,
			side: THREE.DoubleSide,
		}),
		this.cube = new THREE.Mesh(this.geometry, this.material);
		this.cube.receiveShadow = true;
		this.cube.castShadow = true;
		this.cube.position.set(0, 0, 0);
		this.cube.rotation.set(0, 0, 0);

		//this.scene.add(this.cube);
		this.model = this.loader.load('gltf', '/assets/models/monkey/monkey.gltf');
		this.scene.add(this.model);

	}

	updateWorld() {
		this.cube.rotation.x += 0.01;
		this.cube.rotation.y += 0.01;
	}

	setDebug() {
		this.stats = new Stats(this.debug);

		if (this.debug) {
			this.gui = new GUI();
			this.gui.add( this.cube.position, 'x', -1, 1, 0.1 );
		}
	}

	animate() {

		// Stats begin
		this.stats.begin();

		// Call render function and pass in created scene and camera
		this.renderer.render(this.scene, this.camera.threeCamera);

		// Update orbit controls
		this.controls.update();

		this.updateWorld();

		// Stats end
		this.stats.end();

		// RAF
		requestAnimationFrame(this.animate.bind(this)); // Bind the main class instead of window object
		//requestAnimationFrame(this.animate); // Bind the main class instead of window object
	}
}
